export enum Animations {
  FadeIn = 'fadeIn',
  PopOut = 'popOut',
}
